import {
	pipelineByID,
	pipelineCreate,
	pipelineDestroy,
	pipelineList,
	pipelineUpdate,
} from '@/services/pipelines.service'

export default {
	namespaced: true,
	state: {
		// SERVICE PIPELINE
		pipelineList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		pipeline: {},

		// STATUS SERVICE PIPELINE
		pipelineStatus: 'pending',
		pipelineSaveStatus: 'init',
		pipelineDeleteStatus: 'init',
	},
	getters: {
		// SERVICE PIPELINE
		getPipelineList(state) {
			return state.pipelineList
		},
		getPipeline(state) {
			return state.pipeline
		},

		// SERVICE STATUS
		getStatusList(state) {
			return state.statusList
		},
		getStatus(state) {
			return state.status
		},

		// SERVICE PIPELINE
		getPipelineDeleteStatus(state) {
			return state.pipelineDeleteStatus
		},
		getPipelineSaveStatus(state) {
			return state.pipelineSaveStatus
		},
		getPipelineStatus(state) {
			return state.pipelineStatus
		},
	},
	mutations: {
		// SERVICE PIPELINE
		PIPELINE_LIST(state, value) {
			state.pipelineList = value
		},
		SET_PIPELINE(state, value) {
			state.pipeline = value
		},

		// STATUS SERVICE PIPELINE
		PIPELINE_STATUS(state, value) {
			state.pipelineStatus = value
		},
		PIPELINE_SAVE_STATUS(state, value) {
			state.pipelineSaveStatus = value
		},
		PIPELINE_DELETE_STATUS(state, value) {
			state.pipelineDeleteStatus = value
		},
	},
	actions: {
		// Service Pipeline
		async fetchPipelineList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('PIPELINE_STATUS', 'pending')
			commit('PIPELINE_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const { data } = await pipelineList(params)
				commit('PIPELINE_STATUS', 'init')
				commit('PIPELINE_LIST', data)
				return data
			} catch (error) {
				commit('PIPELINE_STATUS', 'init')
				throw error
			}
		},
		async fetchPipelineByID({ commit }, params) {
			commit('PIPELINE_STATUS', 'pending')
			try {
				const { data } = await pipelineByID(params)
				commit('PIPELINE_STATUS', 'init')
				commit('SET_PIPELINE', data.data)
				return data
			} catch (error) {
				commit('PIPELINE_STATUS', 'init')

				return error
			}
		},
		async saveNewPipeline({ commit }, params) {
			commit('PIPELINE_SAVE_STATUS', 'pending')
			try {
				const { data } = await pipelineCreate(params)
				commit('PIPELINE_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('PIPELINE_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updatePipeline({ commit }, params) {
			commit('PIPELINE_SAVE_STATUS', 'pending')
			try {
				const { data } = await pipelineUpdate(params)
				commit('PIPELINE_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('PIPELINE_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deletePipelineByID({ commit }, params) {
			commit('PIPELINE_DELETE_STATUS', 'pending')
			try {
				const { data } = await pipelineDestroy(params)
				commit('PIPELINE_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('PIPELINE_DELETE_STATUS', 'error')

				return error
			}
		},
	},
}
